import React from 'react'
import styled, { StyledProps } from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
`

type Option = {
  id: string | number | boolean
  title: string
  disabled?: boolean
}

type OptionColorProps = Pick<Option, 'disabled'> & { selected: boolean }

const pickOptionColor = ({ theme, selected, disabled }: StyledProps<OptionColorProps> & OptionColorProps) => {
  if (disabled) {
    return theme.color.secondary200
  } else if (selected) {
    return theme.color.onPrimaryLight
  } else {
    return theme.color.primary600
  }
}

const Button = styled.button<StyledProps<{ selected: boolean }>>`
  ${({ theme, selected, disabled }) => ({
    background: selected ? theme.color.primary600 : 'transparent',
    border: `1px solid ${disabled ? theme.color.secondary200 : theme.color.primary600}`,
    color: pickOptionColor({ selected, disabled, theme }),
  })}

  box-sizing: border-box;
  width: 160px;
  height: 56px;

  border-radius: 8px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  outline: none;

  cursor: pointer;

  &:hover {
    ${({ theme, selected }) => !selected && { background: theme.color.primary25 }}
  }

  &:disabled {
    cursor: not-allowed;
  }

  &:not(:first-child) {
    margin-left: 16px;
  }
`

export const SwitchButton: React.FC<{
  options: Option[]
  onChange(id: string | number | boolean): void
  value?: string | number | boolean
  testId?: string
}> = ({ options, onChange, value, testId }) => (
  <Wrapper data-test-id={testId}>
    {options.map((opt: Option, i) => (
      <Button
        type={'button'}
        onClick={() => onChange(opt.id)}
        key={i}
        selected={opt.id === value}
        disabled={opt.disabled}
      >
        {opt.title}
      </Button>
    ))}
  </Wrapper>
)
